import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

const withRouter = (WrappedComponent) => (props) => {
  const params = useParams()
  const location = useLocation();
  const history = useNavigate();

  return( 
    <WrappedComponent 
        {...props} 
        params={params} 
        history={history} 
        location={location}
    />
  );
};

export default withRouter;